import script from "./gradient-shape.vue?vue&type=script&setup=true&lang=ts"
export * from "./gradient-shape.vue?vue&type=script&setup=true&lang=ts"

import "./gradient-shape.vue?vue&type=style&index=0&id=4af38d6d&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Cloud Strife\\Desktop\\kronoku-repaint\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4af38d6d"]])

export default __exports__